import React, { useContext, useState, useRef, useEffect } from "react";
import ReactDOM from 'react-dom';
import { useTranslation } from "react-i18next";
import { Card } from "react-bootstrap"
import { IconButton } from "@fluentui/react";
import JqxGrid, { jqx } from 'jqwidgets-scripts/jqwidgets-react-tsx/jqxgrid';
import { getGridLocalization, isNullUndefinedOrEmpty, showMessage } from "../../common/Helpers";
import MessageBox from "../../components/Common/Message/MessageBox";
import { __MessageTypes } from "../../common/Dictionaries";
import MainAppContext from "../../MainAppContext";
import MatrixToolbar from "../../components/Products/sPrivilege/Matrix/MatrixToolbar";
import * as XLSX from 'xlsx';
import { applyFilters, executeScrollMovementToFixLockRowOnEditCell, handlerFilter, setterActionFired, useFilterActionComponentData } from "../../common/Helpers/JqxGridFilter";
import { getIntegrationdictionarykpi as getItem, addIntegrationdictionarykpiList as addListItems, addIntegrationdictionarykpi as addItem, saveIntegrationdictionarykpi as saveItem, deleteIntegrationdictionarykpi as deleteItem} from "../../services/sIntegration/integration.service";
import { useGetAllIntegrationdictionarykpi as useGetAllItems } from "../../hooks/services/sIntegration/useOfIntegration";
import 'jqwidgets-scripts/jqwidgets/styles/jqx.light.css';
export default function IntegrationDictionaryKpi() {
    const { t } = useTranslation();
    const contextSite = useContext(MainAppContext);
    const profileHasAccess = !contextSite.onlyObserver || (contextSite.securityProps.isSAdmin ||  contextSite.securityProps.isAdmin)

    const gridRef = useRef();

    const [showRequiredGlobalMessage, setShowRequiredGlobalMessage] = useState(false);
    const [editingRows, setEditingRows] = useState([]);

    const [messageConfig, setMessageConfig] = useState({
        message : null,
        messageType : "",
        showMessage : false,
    });

    const [listItems, setListItems] = useState(null);    
    useGetAllItems(listItems, setListItems);
    
    useFilterActionComponentData(gridRef, messageConfig, "IntegrationDictionaryKpi");

    const handlerAddNewRow = (obj) => {
        const records = gridRef.current.props.source.records;
        const _lowerId = records.length !== 0 ? records.reduce((min, obj) => obj.id < min ? obj.id : min, records[0].id) : 0;
        const lowerId = records.length === 0 ? -1 : (_lowerId > 0 ? ((_lowerId * -1) - 1) : _lowerId -1);

        const newRow = !obj ? {
            id:             lowerId,
            variableId :    '',
            variableName:   '',
            v1Name :        '',
            v2Name :        '',
            kpiValName :    '',
            active :        true,
           
        } : {
            id:             lowerId,
            variableId :    obj.variableId,
            variableName:   obj.variableName,
            v1Name :        obj.v1Name,
            v2Name :        obj.v2Name,
            kpiValName :    obj.kpiValName,
            active :        obj.active
        };

        gridRef.current.beginupdate();
        gridRef.current.addrow(null, newRow, 'first');

        listItems.unshift(newRow);
        setListItems(listItems);

        if (editingRows.length > 0 ? editingRows.find(x => x === lowerId) === undefined : true) {
            editingRows.push(lowerId);
            setEditingRows(editingRows);
        }

        gridRef.current.endupdate();
        gridRef.current.updatebounddata('rows');
        setterActionFired("IntegrationDictionaryKpi", 1);
    };
    
    const getValue = (column, row) => {
        const itemValue = column.editorOptions.find(x => x.key === row[column.dataField])

        return !isNullUndefinedOrEmpty(itemValue) ? itemValue.text : "";
    }

    const handlerExportData = (exportData) => {
        const workbook = XLSX.utils.book_new();
        const columns = getColumns()
        const aux_rows = []

        if (exportData) {
            const aux_list = listItems.filter(x => x.id > 0);

            aux_list.forEach(row => {
                let aux_row = {};
                columns.forEach(column => {
                    if (column.exportable) {
                        if (column.columntype === 'dropdownlist') {
                            aux_row[column.dataField] = row[column.dataField] !== null ? getValue(column, row) : "";
                        }
                        else {
                            aux_row[column.dataField] = row[column.dataField];
                        }
                    }
                });
    
                aux_rows.push(aux_row);
            });
        }

        const worksheet = XLSX.utils.json_to_sheet(aux_rows, { header: columns.filter(x => (exportData ? x.exportable : x.uploadMasive)).map(column => column.dataField) });
        
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Data');
        XLSX.writeFile(workbook, 'IntegrationDictionatyKpi_ExportedData.xlsx');
    };

    const isInValidFormControls = (list) => {
        let isInvalidForm = false;
        const validItems = [];

        list.forEach(element => {
            if (validateObject(element)) {
                validItems.push(element);
            }
            else {
                isInvalidForm = true;
            }
        });
    
        return {isInvalidForm: isInvalidForm, validItems: validItems};
    };
    
    const handlerSaveAll = async () => {
        const elementosFiltrados = listItems.filter(objeto => editingRows.includes(objeto.id));
        console.log(elementosFiltrados);

        const valid_response = isInValidFormControls(elementosFiltrados);

        if (valid_response.validItems) {
            await addListItems(valid_response.validItems).then(async (response) => {
                if (response.data.succeeded) {
                    setEditingRows([]);
                    setListItems(response.data.data);
                    showMessage(setMessageConfig, true, __MessageTypes.SUCCESS, t('data-lang-msg-operationperformed'));
                }
                else {
                    showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'));
                }
                setterActionFired("IntegrationDictionaryKpi", 1);
            }).catch(() => {
                showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'));
                setterActionFired("IntegrationDictionaryKpi", 1);
            });
        }
        else {
            showMessage(setMessageConfig, true, __MessageTypes.WARNING, t('data-lang-msg-requireddatanotset'));
        }
    };

    const handlerSave = async (itemId) => {       
        const item = gridRef.current.props.source.records.find(x => parseInt(x.id) === itemId);

        if (validateObject(item)) {
            if (item.id <= 0) {                
                await addItem(item).then(async (serviceResponse) => {
                    if (serviceResponse.data.succeeded) {
                        setEditingRows(editingRows.filter(x => x !== item.id));

                        listItems.forEach(element => {
                            if (element.id === parseInt(item.id)) {
                                element.id = serviceResponse.data.data;
                                element.variableId = item.variableId;
                                element.variableName = item.variableName;
                                element.v1Name = item.v1Name;
                                element.v2Name = item.v2Name;
                                element.kpiValName = item.kpiValName;
                                element.active = item.active;
                            }
                        });
                                               
                        setListItems(listItems);
                        showMessage(setMessageConfig, true, __MessageTypes.SUCCESS, t(serviceResponse.data.message));
                    }
                    else {
                        showMessage(setMessageConfig, true, __MessageTypes.ERROR, t(serviceResponse.data.message));
                    }        
                    setterActionFired("IntegrationDictionaryKpi", 1);
                }).catch(() => {
                    showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'));
                    setterActionFired("IntegrationDictionaryKpi", 1);
                });
            }
            else {
                await saveItem(item.id, item).then(async (serviceResponse) => {
                    if (serviceResponse.data.succeeded) {
                        setEditingRows(editingRows.filter(x => x !== item.id));

                        showMessage(setMessageConfig, true, __MessageTypes.SUCCESS, t(serviceResponse.data.message));
                    }
                    else {
                        showMessage(setMessageConfig, true, __MessageTypes.ERROR, t(serviceResponse.data.message));
                    }  
                    setterActionFired("IntegrationDictionaryKpi", 1);
                }).catch(() => {
                    showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'));
                    setterActionFired("IntegrationDictionaryKpi", 1);
                });
            } 

            setShowRequiredGlobalMessage(false);
        }
        else {
            setShowRequiredGlobalMessage(true);
        }
    };

    const handlerDelete = async (itemId) => {        
        if (itemId <= 0) {
            const newListItems = gridRef.current.props.source.records.filter(x => x.id.toString() !== itemId.toString());
            setListItems(newListItems);
            setEditingRows(editingRows.filter(x => x.toString() !== itemId.toString()));
        }
        else {
            await deleteItem(itemId).then(async (serviceResponse) => {
                if (serviceResponse.data.succeeded) {                    
                    const newListItems = gridRef.current.props.source.records.filter(x => x.id.toString() !== itemId.toString());

                    setListItems(newListItems);
                    setEditingRows(editingRows.filter(x => x.toString() !== itemId.toString()));
                    showMessage(setMessageConfig, true, __MessageTypes.SUCCESS, t('data-lang-msg-operationperformed'));
                    
                    gridRef.current.updatebounddata('rows');                   
                }
                else {
                    showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'));
                }
                setterActionFired("IntegrationDictionaryKpi", 1);
            }).catch(() => {
                showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'));
                setterActionFired("IntegrationDictionaryKpi", 1);
            });
        }
    };

    const handlerCancel = async (itemId) => {
        if (itemId === null) {
            const newListItems = listItems.filter(x => x.id !== itemId);
            setListItems(newListItems);
            setEditingRows(editingRows.filter(x => x !== itemId));
            showMessage(setMessageConfig, true, __MessageTypes.SUCCESS, t('data-lang-msg-operationperformed'));    
            setterActionFired("IntegrationDictionaryKpi", 1);
        }
        else
        {
            await getItem(itemId).then(async (serviceResponse) => {
                if (serviceResponse.data.succeeded) {
                    listItems.forEach(element => {
                        if (serviceResponse.data.data.id === element.id) {
                            for (const property in serviceResponse.data.data) {
                                element[property] = serviceResponse.data.data[property];
                            }
                        }
                    });
            
                    setListItems(listItems);
                    setEditingRows(editingRows.filter(x => x !== itemId));
                    showMessage(setMessageConfig, true, __MessageTypes.SUCCESS, t('data-lang-msg-operationperformed'));
                }
                else {
                    showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'));
                }
                setterActionFired("IntegrationDictionaryKpi", 1);
            }).catch(() => {
                showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'));
                setterActionFired("IntegrationDictionaryKpi", 1);
            });
        }
    };

    const validateObject = (object) => {
        let isValid = object.variableId !== undefined && object.variableId !== null && object.variableId > 0;
        isValid = isValid ? (object.v1Name !== undefined && object.v1Name !== null && object.v1Name !== '') : isValid;
        isValid = isValid ? (object.v2Name !== undefined && object.v2Name !== null && object.v2Name !== '') : isValid;
        //isValid = isValid ? (object.kpiValName !== undefined && object.kpiValName !== null && object.kpiValName !== '') : isValid;

        return isValid;
    };

    const getRowIdFromRowIndex = (rowIndex) => {
        if (typeof rowIndex === 'object' && rowIndex.boundindex !== undefined) {
            return rowIndex.bounddata.id;
        }
        return listItems[rowIndex]?.id;
    };

    const onCellvaluechanged = (e) => {

        listItems[e.args.rowindex][e.args.datafield] = e.args.value;
        
        const copia_listItems = JSON.parse(JSON.stringify(listItems));
        setListItems(copia_listItems);

        if (editingRows.find(x => x === listItems[e.args.rowindex].id) === undefined) {
            editingRows.push(listItems[e.args.rowindex].id);
        }

        setEditingRows(editingRows);
        applyFilters(gridRef, 'IntegrationDictionaryKpi', false);

        executeScrollMovementToFixLockRowOnEditCell(gridRef);
    };

    const actionCellsRenderer = (row) => {        
        const itemId = getRowIdFromRowIndex(row);
        const isEditing = editingRows.find(x => x === itemId);
        
        return  <>
                    {isEditing ? (
                        <>
                            {
                                itemId <= 0 ? (
                                    <>
                                        <IconButton iconProps={{ iconName: 'Save' }} title="Guardar" ariaLabel="Guardar" onClick={() => fieldActionHandler(itemId, 'save')} />
                                        <IconButton iconProps={{ iconName: 'Delete' }} title="Eliminar" ariaLabel="Eliminar" onClick={() => fieldActionHandler(itemId, 'delete')} />
                                    </>
                                ) : (
                                    <>
                                        <IconButton iconProps={{ iconName: 'Save' }} title="Guardar" ariaLabel="Guardar" onClick={() => fieldActionHandler(itemId, 'save')} />
                                        <IconButton iconProps={{ iconName: 'Cancel' }} title="Cancelar" ariaLabel="Cancelar" onClick={() => fieldActionHandler(itemId, 'cancel')} />
                                        <IconButton iconProps={{ iconName: 'Delete' }} title="Eliminar" ariaLabel="Eliminar" onClick={() => fieldActionHandler(itemId, 'delete')} />
                                    </>
                                )
                            }
                        </>
                    ) : (
                        <IconButton iconProps={{ iconName: 'Delete' }} title="Eliminar" ariaLabel="Eliminar" onClick={() => fieldActionHandler(itemId, 'delete')} />
                    )}
                </>
    };

    const fieldActionHandler = (id, actionType) => {
        switch (actionType) {
            case 'save':
                handlerSave(id);
                break;
            case 'delete':
                handlerDelete(id);
                break;
            case 'cancel':
                handlerCancel(id);
                break;
            default:
                break;
        }
    };

    const cellsRenderer = (rowIndex, cellValue, editor, cellText, width, height, auxListData, cellType, subType) => {
        switch (cellType) {
            case 'textbox':
                switch (subType) {
                    case "currency":
                        editor.jqxNumberInput({
                            decimalDigits: 3,
                            width: width,
                            spinButtons: false,
                            symbol: '$',
                            groupSeparator: ',',
                            decimalSeparator: '.',
                        });
                        break;
                    case "number":
                        editor.jqxNumberInput({
                            decimalDigits: 3,
                            width: width,
                            spinButtons: true,
                            groupSeparator: ',',
                            decimalSeparator: '.',
                        });
                        break;
                    default:
                        break;
                }
                break;
            case 'datetimeinput':
                break;
            case 'checkbox':
                editor.jqxCheckBox({ width: width });
                break;
                case 'dropdownlist':
                editor.jqxDropDownList({
                    width: width,
                    height: height,
                    source: getListColumnAdapter(auxListData, 'key', 'text'),
                    displayMember: 'text',
                    valueMember: 'key',
                    autoDropDownHeight: auxListData.length < 5
                });
            default:
                break;
        }
    };

    const getListColumnAdapter = (listObjetcs, key, text) => {
        return new jqx.dataAdapter({
            datafields: [
                { name: text, type: 'string' },
                { name: key, type: 'number' }
            ],
            datatype: 'array',
            localdata: listObjetcs
        }, { autoBind: true });
    };

    const cellRenderClassStyle = (row, columnfield, value, columnType) => {
        let className = "";
        switch (columnType) {
            case "textbox":
                if (value === '') {
                    className = 'jqx-custom-validation-red';
                }
                else {
                    className = '';
                }
                break;
            case "numberinput":
                if (value < 0 || value === '') {
                    className = 'jqx-custom-validation-red';
                }
                else {
                    className = '';
                }
                break;
            case "datetimeinput":
                if (value === '') {
                    className = 'jqx-custom-validation-red';
                }
                else {
                    className = '';
                }
                break;
            case "dropdownlist":
                if (value === null || value === '' || value === 0) {
                    className = 'jqx-custom-validation-red';
                }
                else {
                    className = '';
                }
                break
            default:
                break;
        }

        return className;
    };
    
    const getColumns = () => {
        const basicColumns =[
            { index: null, text: 'Id', dataField: 'id', width: '0px', hidden: true, exportable: true, createeditor: (rowIndex, cellValue, editor, cellText, width, height) =>  cellsRenderer(rowIndex, cellValue, editor, cellText, width, height, null, 'textbox', 'string'), columntype: 'textbox', cellclassname: (row, columnfield, value) => cellRenderClassStyle(row, columnfield, value, 'textbox'), editable: profileHasAccess ?? false, pinned: true},
            { index: null, text: t('data-lang-lbl-actions'),       dataField: 'acciones',      uploadMasive: false, exportable: false, width: '7%', pinned: true, filterable: false,
                createwidget: (row, column, value, htmlElement) => { ReactDOM.render(actionCellsRenderer(row), htmlElement); },
                initwidget: (row, column, value, htmlElement) => { ReactDOM.render(actionCellsRenderer(row), htmlElement); },
            },
            { index: 0, text: t('data-lang-lbl-field-variableid'), dataField: 'variableId',   width: '12%', exportable: true, createeditor: (rowIndex, cellValue, editor, cellText, width, height) =>  cellsRenderer(rowIndex, cellValue, editor, cellText, width, height, null, 'textbox', 'string'), columntype: 'textbox', cellclassname: (row, columnfield, value) => cellRenderClassStyle(row, columnfield, value, 'textbox'), editable: profileHasAccess, pinned: true },
            { index: 1, text: t('data-lang-lbl-variablename'),     dataField: 'variableName', width: '42%', exportable: true, createeditor: (rowIndex, cellValue, editor, cellText, width, height) =>  cellsRenderer(rowIndex, cellValue, editor, cellText, width, height, null, 'textbox', 'string'), columntype: 'textbox', editable: false, pinned: true},
            { index: 2, text: t('data-lang-lbl-field-v1name'),     dataField: 'v1Name',       width: '7%',  exportable: true, createeditor: (rowIndex, cellValue, editor, cellText, width, height) =>  cellsRenderer(rowIndex, cellValue, editor, cellText, width, height, null, 'textbox', 'string'), columntype: 'textbox', editable: profileHasAccess },
            { index: 3, text: t('data-lang-lbl-field-v2name'),     dataField: 'v2Name',       width: '7%',  exportable: true, createeditor: (rowIndex, cellValue, editor, cellText, width, height) =>  cellsRenderer(rowIndex, cellValue, editor, cellText, width, height, null, 'textbox', 'string'), columntype: 'textbox', editable: profileHasAccess },
            { index: 4, text: t('data-lang-lbl-field-kpivalname'), dataField: 'kpiValName',   width: '20%', exportable: true, createeditor: (rowIndex, cellValue, editor, cellText, width, height) =>  cellsRenderer(rowIndex, cellValue, editor, cellText, width, height, null, 'textbox', 'string'), columntype: 'textbox', editable: profileHasAccess },
            { index: 5, text: t('data-lang-lbl-field-active'),     dataField: 'active',       width: '5%',  exportable: true, createeditor: (rowIndex, cellValue, editor, cellText, width, height) =>  cellsRenderer(rowIndex, cellValue, editor, cellText, width, height, null, 'checkbox', 'string'),columntype: 'checkbox', cellclassname: (row, columnfield, value) => cellRenderClassStyle(row, columnfield, value, 'textbox'), editable: profileHasAccess },
        ]

        return basicColumns;
    };

    return (
        <div className="col-12 listWithActions h-100">
            <Card className="h-100">
                <Card.Header>
                    <Card.Title className="d-flex justify-content-between">
                        <h4><b>{t('data-lang-maintainer-title-IntegrationDictionaryKpi')}</b></h4>
                    </Card.Title>
                </Card.Header>
                <Card.Footer>
                    <MessageBox
                        inputParam_Message={ messageConfig.message }
                        inputParam_Display={ messageConfig.showMessage }
                        inputParam_MessageType={ messageConfig.messageType }
                        inputParam_SetterMessage={ setMessageConfig }
                    />
                </Card.Footer>
                <Card.Body className="access-per-month-form-body h-100 overflow-hidden-deprecated">
                    <div className="align-items-center h-100">
                        <div className="d-none">                                                        
                            <a id="btnGetTemplateJson" href={undefined} download="Template.csv" style={{display: "none"}} rel="noreferrer noopener" target='_blank'>#</a>
                        </div>
                        {
                            listItems &&
                            <>
                                <MatrixToolbar
                                    inputParam_HandleSaveData={handlerSaveAll}                                    
                                    inputParam_HandleUploadData={undefined}
                                    inputParam_HandleExportData={handlerExportData}
                                    inputParam_HandleAddRow={handlerAddNewRow}
                                    inputParam_Configuration={{
                                        buttons: {
                                            showRowButtons: false,
                                            showExportData: profileHasAccess,
                                            showAddMasiveData: false,
                                            showAddData: profileHasAccess,
                                            showDownloadTemplate: false,
                                            showSaveAllData: profileHasAccess,
                                            groupedButtons: false
                                        },
                                        handlers: {
                                            handlerSave: profileHasAccess ? handlerSave : null,
                                            handlerSaveAll: profileHasAccess ? handlerSaveAll : null,
                                            handlerDelete: profileHasAccess ? handlerDelete : null,
                                            handlerCancel: profileHasAccess ? handlerCancel : null,
                                        },
                                        auxiliarListCallbackOnAdd: null,
                                    }}
                                    inputParam_ExternalExportTemplates={[
                                        {
                                            id: 'btnMantGetTemplate',
                                            key: 'btnMantGetTemplate',
                                            text: t('data-lang-lbl-uploadtemplate'),
                                            iconProps: { iconName: 'ExcelDocument' },
                                            onClick: () => handlerExportData(false)
                                        }
                                    ]}
                                    showRequiredMessage={showRequiredGlobalMessage}
                                />
                                <JqxGrid
                                    ref={gridRef}
                                    altrows={false}
                                    enabletooltips={true}
                                    width={'100%'}
                                    theme={'light'} 
                                    editable={true}
                                    height={"550px"}
                                    sortable={true}
                                    filterable={true}
                                    showfilterrow={true} 
                                    localization={getGridLocalization(t)}
                                    source={ new jqx.dataAdapter({
                                        localData: listItems,
                                        dataType: 'array',
                                        dataFields: [            
                                            { name: 'id', type: 'int' },
                                            { name: 'variableId', type: 'string' },
                                            { name: 'variableName', type: 'string' },
                                            { name: 'v1Name', type: 'string' },
                                            { name: 'v2Name', type: 'string' },
                                            { name: 'kpiValName', type: 'string' },
                                            { name: 'active', type: 'bool' },
                                        ],
                                        id: 'id'
                                    })}
                                    columns={getColumns()}
                                    onCellvaluechanged={onCellvaluechanged} 
                                    onFilter={(event) => handlerFilter(event, 'IntegrationDictionaryKpi')}
                                />
                            </>
                        }
                    </div>
                </Card.Body>
            </Card>           
        </div>
    ); 
}

